import React from "react";
import { Button } from "./UI";

type ReloadProps = React.ComponentPropsWithoutRef<"div">;

const Reload = (props: ReloadProps) => {
  const { children, ...restProps } = props;

  return (
    <div data-testid="reload-container" className="reload" {...restProps}>
      <div>{children}</div>
      <Button
        id="reload"
        color="white"
        onClick={() => window.location.reload()}
      >
        Muat Ulang
      </Button>
      <style jsx>{`
        .reload {
          width: 100%;
          padding: 16px;
          margin: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 8px;
        }

        .reload > div {
          margin-right: 8px;
          font-size: 12px;
        }
      `}</style>
    </div>
  );
};

export default Reload;
